const SERVER_URL = "https://backend.intractapp.in/";
// const SERVER_URL = "http://localhost:8000/";
// const SERVER_URL = "http://192.168.0.104:8000/";
// const SERVER_URL = "http://app.intractapp.in:8001/";

// const SERVER_URL = 'http://101.53.132.216:8000/';
// const SERVER_URL = 'https://app.intractapp.in/';
// 
// const SERVER_URL = "http://backend.intractapp.in:8000/";

const endpoints = {
	testsBaseURL: 'http://localhost:8080',
	// INSTITUTION SETTINGS
	getStaffPrivileges: SERVER_URL + 'erp/privileges/staff/all/',
	saveStaffPrivileges: SERVER_URL + 'erp/privileges/staff/save/',
	userDocumentTypes: SERVER_URL + 'base/userdocumenttypes/',
	userAttributes: SERVER_URL + 'base/userattributes/',
		
    // Auth endpoints
    obtainJWT: SERVER_URL + 'jauth/jwt/create/',
	refreshJWT: SERVER_URL + 'jauth/jwt/refresh/',
	authenticateSubordinateUser: SERVER_URL + 'base/users/subordinate/authenticate/',
	getMyDetails: SERVER_URL + 'base/users/me/',
	getInstitutionDetails: SERVER_URL + 'base/institution/id/',
	getRoomFromSections: SERVER_URL + 'base/rooms/get/',
	checkInstitutionCode: SERVER_URL + 'base/institution/code/check/',
	getInstitutionDetailsByCode: SERVER_URL + 'base/institution/code/',
	getInstitutionDetailsById: SERVER_URL + 'base/institution/id/',
	defaultProfileImage: SERVER_URL + 'media/users/default/default.jpg',

	requestSupport: SERVER_URL + 'support/request/create/',

	tourHistory: SERVER_URL + 'onboarding/tour/history/',

	// Departments
	getDepartments: SERVER_URL + 'base/departments/',

	changePassword: SERVER_URL + 'erp/staff/password/change/',
	sendPasswordResetEmail: SERVER_URL + 'erp/staff/password/reset/email/',
	verifyResetPasswordToken: SERVER_URL + 'erp/staff/password/reset/token/verify/',
	resetPassword: SERVER_URL + 'erp/base/user/password/reset/',
	resetStaffPassword: SERVER_URL + 'erp/base/staff/password/reset/',
	
	institutionsViewSet: SERVER_URL + 'base/institutions/',
	academicSessionsViewSet: SERVER_URL + 'base/academic_sessions/',

	// DASHBOARD
	getDashboardCounts: SERVER_URL + 'erp/dashboard/counts/',
	getDashboardBoardPosts: SERVER_URL + 'erp/dashboard/board/posts/',
	getDashboardCalendar: SERVER_URL + 'erp/dashboard/calendar/',
	getDashboardActionLogs: SERVER_URL + 'erp/dashboard/action_logs/',

	// ROOMS
	getAllClassRooms: SERVER_URL + 'erp/classrooms/all/',
	getClassRoomDetails: SERVER_URL + 'erp/classrooms/details/',
	getClassRoomStudents: SERVER_URL + 'erp/classrooms/students/',
	editClassRoom: SERVER_URL + 'erp/classrooms/edit/',
	sectionCategories: SERVER_URL + 'erp/classrooms/section-categories/',
	getSections: SERVER_URL + 'erp/classrooms/sections/',
	addEditClassRoom: SERVER_URL + 'erp/classrooms/add-or-edit/',
	checkClassroomExists: SERVER_URL + 'erp/classrooms/check-unique-classroom/',

	getAllRooms: SERVER_URL + 'erp/rooms/',

	// SUBJECTS
	getClassRoomSubjects: SERVER_URL + 'erp/classrooms/subjects/',
	// editClassroomSubjects: SERVER_URL + 'erp/classrooms/subjects/edit/',
	createOrEditSubject: SERVER_URL + 'erp/subjects/create_or_edit/',
	deleteSubject: SERVER_URL + 'erp/subjects/delete/',

	// STUDENTS
	getAllStudents: SERVER_URL + 'erp/students/all/',
	getStudentDetails: SERVER_URL + 'erp/students/details/',
	createOrEditStudent: SERVER_URL + 'erp/students/create_or_edit/',
	getStudentAttributes: SERVER_URL + 'erp/students/custom_attributes/',
	getRooms: SERVER_URL + 'erp/rooms/',
	refundFeesForChangingRoom: SERVER_URL + 'erp/students/rooms/change/refund/',
	checkUsernameExists: SERVER_URL + "base/user/check_username_exists/",
	softDeleteStudent: SERVER_URL + "erp/students/delete/soft/",
	deleteCurrentStudentRecord: SERVER_URL + "erp/students/delete/current/",
	deletedStudents: SERVER_URL + 'base/students/deleted/',
	deletedCurrentStudentRecords: SERVER_URL + 'base/students/current/deleted/',
	disableStudent: SERVER_URL + 'admin-panel/classrooms/students/disable/',

	// Staff
	getOnlyFaculty: SERVER_URL + 'erp/faculty/only/all/',
	getAllStaff: SERVER_URL + 'erp/staff/all/',
	getStaffDetails: SERVER_URL + 'erp/staff/details/',
	getFacultySubjects: SERVER_URL + 'erp/staff/subjects/',
	getStaffAttributes: SERVER_URL + 'erp/staff/custom_attributes/',
	createOrEditStaff: SERVER_URL + 'erp/staff/create_or_edit/',
	softDeleteStaff: SERVER_URL + "erp/staff/delete/soft/",
	deletedStaff: SERVER_URL + 'base/staff/deleted/',
	dailyReportsViewSet: SERVER_URL + 'base/daily_reports/',
	departmentViewSet: SERVER_URL + 'base/department/',
	disableStaff: SERVER_URL + 'admin-panel/faculty/disable/',

	// getAllStaffAttendance: SERVER_URL + 'erp/staff/attendance/monthly/',
	// getStaffAttendance: SERVER_URL + 'erp/staff/attendance/all/',
	// getAllStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/single/',
	// getStaffAttendanceAnalytics: SERVER_URL + 'erp/staff/attendance/chart/',
	// addStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/entries/add/',	// save attendance entries
	// deleteStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/entries/delete/', 		// delete attendance entries
	// getAllStaffCategory: SERVER_URL + 'erp/staff/attendance/settings/categories/',		// To fetch all staff categories
	// addEditStaffCategory: SERVER_URL + 'erp/staff/attendance/settings/categories/',		// to add/edit staff categories(POST)

	//Payroll
	getPayrollAccounts: SERVER_URL + 'erp/payroll/accounts/',
	getStaffHRAccounts: SERVER_URL + 'erp/payroll/hraccounts/',
	changePayrollGroup: SERVER_URL + 'erp/payroll/groups/employees/allocate/',
	addPayrollGroups: SERVER_URL + 'erp/payroll/groups/',
	getPayrollParticulars: SERVER_URL + 'erp/payroll/particulars/',
	payrollGroups: SERVER_URL + 'erp/payroll/groups/',
	generatePayslip: SERVER_URL + 'erp/payroll/payslips/generate/',
	payslipGroups: SERVER_URL + 'erp/payroll/payslips/groups/',
	payslip: SERVER_URL + 'erp/payroll/payslips/',
	payrollPendingActions : SERVER_URL + 'erp/payroll/payslips/pending_actions/',
	payslipSettings: SERVER_URL + 'erp/payroll/settings/payslip/',


	// finance
	financeCategories: SERVER_URL + 'finance/categories/',
	financeSubCategories: SERVER_URL + 'finance/sub-categories/',
	financeReceiptSettings: SERVER_URL + 'finance/settings/receipt/',
	financePreferences: SERVER_URL + 'finance/settings/preferences/',
	financeTransactions: SERVER_URL + 'finance/transactions/',
	financeReports: SERVER_URL + 'finance/transactions/category-summary-reports/',
	financeAccountTransfer: SERVER_URL + 'finance/transactions/account-transfer/',
	accountSummaryReports: SERVER_URL + 'finance/transactions/account-summary-reports/',
	financeReportsCompare: SERVER_URL + 'finance/transactions/category-summary-reports/compare/',
	financeExport: SERVER_URL + 'finance/transactions/export/',
	financeAnalytics: SERVER_URL + 'finance/transactions/analytics/',
	financeAccounts: SERVER_URL + 'finance/accounts/',
	// only teaching faculty
	getAllFaculty: SERVER_URL + 'erp/faculty/all/',

	// FEES
	// Fee accounts
	getAllFeeAccounts: SERVER_URL + 'erp/fees/accounts/all/',
	saveStudentCategory: SERVER_URL + 'erp/fees/accounts/student/category/save/',
	getStudentRoomCategories: SERVER_URL + 'erp/fees/accounts/room/categories/',
	softDeleteFeeAccount: SERVER_URL + 'erp/fees/accounts/soft/delete/',

	// Fee Categories
	getAllCategories: SERVER_URL + 'erp/fees/categories/all/',
	getCategoryById: SERVER_URL + 'erp/fees/categories/',
	createOrEditCategory: SERVER_URL + 'erp/fees/categories/add_or_edit/',
	deleteFeeCategory: SERVER_URL + 'erp/fees/categories/delete/',
	readjustStudentsFeesAndChangeCategory: SERVER_URL + 'erp/fees/categories/students/adjust/',

	// Fee Particulars
	getAllParticulars: SERVER_URL + 'erp/fees/particulars/all/',
	
	getFeeParticularById: SERVER_URL + 'erp/fees/particulars/',
	createOrEditParticular: SERVER_URL + 'erp/fees/particulars/add_or_edit/',
	deleteFeeParticular: SERVER_URL + 'erp/fees/particulars/delete/',
	feeParticularTags: SERVER_URL + 'fees/particulars/tags/',

	// Fee Schedule
	getAllFeeSchedules: SERVER_URL + 'erp/fees/schedules/all/',
	getFeeScheduleById: SERVER_URL + 'erp/fees/schedules/',
	createOrEditSchedule: SERVER_URL + 'erp/fees/schedules/add_or_edit/',
	deleteFeeSchedule: SERVER_URL + 'erp/fees/schedules/delete/',
	deleteFeeScheduleInstalment: SERVER_URL + 'erp/fees/schedules/instalments/delete/',
	
	// Fee Structure
	getAllFeeStructures: SERVER_URL + 'erp/fees/structures/all/',
	getAllRoomCategories: SERVER_URL + 'erp/fees/categories/rooms/',
	getAllRoomParticulars: SERVER_URL + 'erp/fees/particulars/rooms/',
	getAllRoomSchedules: SERVER_URL + 'erp/fees/schedules/rooms/',
	getBasicStructureDetails: SERVER_URL + 'erp/fees/structure/base/details/',
	saveParticularInstalment: SERVER_URL + 'erp/fees/structure/particulars/instalments/save/',
	deleteParticularInstalment: SERVER_URL + 'erp/fees/structure/particulars/instalments/delete/',
	
	// Fee Record
	getFeeRecordsCounts: SERVER_URL + 'erp/fees/records/counts/',
	getAllFeeRecords: SERVER_URL + 'erp/fees/records/all/',
	getFeeStudentProfileDetails: SERVER_URL + 'erp/fees/students/details/basic/',
	getFeeStudentPaymentPlan: SERVER_URL + 'erp/fees/students/payment_plan/',
	getFeeStudentAccountDetails: SERVER_URL + 'erp/fees/students/account/details/',
	getFeeStudentPaymentHistory: SERVER_URL + 'erp/fees/students/payment/history/',
	getFeeReceiptDetails: SERVER_URL + 'erp/fees/students/receipt/',
	addDynamicFeeInstalment: SERVER_URL + 'erp/fees/structure/dynamic/add/',
	// Fee Collection
	getStudentDataForFeeCollection: SERVER_URL + 'erp/fees/collect/students/data/',
	saveStudentFeeTransactions: SERVER_URL + 'erp/fees/collect/students/data/save/',
	
	// Fee Receipt settings
	checkFeeReceiptNumberExists: SERVER_URL + 'erp/fees/receipt/check/',
	getFeeReceiptSettings : SERVER_URL + 'erp/fees/receipt/settings/get/',
	createOrEditFeeReceiptSettings: SERVER_URL + 'erp/fees/receipt/settings/create/',
	deleteFeeReceiptSettings: SERVER_URL + 'erp/fees/receipt/settings/delete/',
	// FeeRefund
	getFeeReundReceiptDetails: SERVER_URL + 'erp/fees/refund/student/receipt/',

	// FEE REPORTS
	getTotalsForReport: SERVER_URL + "erp/fees/reports/totals/",
	getReceiptReports: SERVER_URL + "erp/fees/reports/receipts/",
	getAllReceipts: SERVER_URL + "erp/fees/reports/receipts/all/",
	getAllFeeRefunds: SERVER_URL + "erp/fees/reports/refunds/all/",
	undoFeeReceipt: SERVER_URL + "erp/fees/students/receipts/undo/",

	// FeeSessions
	getFeeSessions: SERVER_URL + "erp/fees/sessions/",

	// Inventory Settings
	storeCategory : SERVER_URL + "erp/inventory/store/category/",
	storeType : SERVER_URL + "erp/inventory/store/type/",
	stores: SERVER_URL + "erp/inventory/store/",
	supplierType: SERVER_URL + "erp/inventory/supplier/type/",
	purchaseOrders: SERVER_URL + "erp/inventory/purchaseorder/",
	storeItem: SERVER_URL + "erp/inventory/store/item/",
	storeItemUnit: SERVER_URL + "erp/inventory/store/item/unit/",
	suppliers: SERVER_URL + "erp/inventory/supplier/",
	grns: SERVER_URL + "erp/inventory/GRN/",

	getInventoryDashboardCounts: SERVER_URL + "erp/inventory/dashboard/counts/",
	getInventoryItemsCounts: SERVER_URL + "erp/inventory/items/counts/",

	// Admissions
	enquirySources: SERVER_URL + 'erp/admission/enquiry/sources/',
	admissions : SERVER_URL + "erp/admission/",
	bulkDeleteAdmissions : SERVER_URL + "erp/admission/bulk/delete/",

	// Student Attendance
	classroomAttendance: SERVER_URL + "erp/attendance/classroom/overall/",
	attendanceDetail: SERVER_URL + "erp/attendance/classroom/monthly/",
	studentAttendance: SERVER_URL + "erp/attendance/student/details/",
	takeAttendance: SERVER_URL + "erp/attendance/take/",
	saveAttendance: SERVER_URL + "erp/attendance/save/",
	studentAttendanceAnalytics: SERVER_URL + "erp/attendance/chart/",

	// Staff Attendance
	getQuickStaffAttendance: SERVER_URL + 'erp/staff/attendance/quick/',
	saveQuickStaffAttendance: SERVER_URL + 'erp/staff/attendance/quick/save/',
	getAllStaffAttendance: SERVER_URL + 'erp/staff/attendance/monthly/',
	getStaffAttendance: SERVER_URL + 'erp/staff/attendance/all/',
	getAllStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/single/',
	getStaffAttendanceAnalytics: SERVER_URL + 'erp/staff/attendance/chart/',
	addStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/entries/add/',	// save attendance entries
	deleteStaffAttendanceEntries: SERVER_URL + 'erp/staff/attendance/entries/delete/', 		// delete attendance entries
	getAllStaffCategory: SERVER_URL + 'erp/staff/attendance/settings/categories/',		// To fetch all staff categories
	addEditStaffCategory: SERVER_URL + 'erp/staff/attendance/settings/categories/',		// to add/edit staff categories(POST)
	getAllStaffAttendanceEntriesForStaff: SERVER_URL +'erp/staff/attendance/entries/staff/',
	getActiveEntry: SERVER_URL + 'erp/staff/attendance/entries/active/',
	biometricTap: SERVER_URL + 'erp/staff/attendance/biometric/tap/',
	
	// getStaffHRAccounts: SERVER_URL + 'erp/payroll/hraccounts/',
	// getStaffHolidays: SERVER_URL + 'erp/staff/attendance/holidays/',		// to fetch, add and edit holidays

	// Staff leave management
	staffLeaveAccounts: SERVER_URL + "erp/staff/attendance/leave/accounts/",
	staffLeaves: SERVER_URL + "erp/staff/attendance/leave/",
	staffLeaveTypes: SERVER_URL + "erp/staff/attendance/leave/types/",
	getStaffCategoryAllowances: SERVER_URL + "erp/staff/attendance/leave/category/allowances/",
	getAllStaffLeaveAllowances: SERVER_URL + "erp/staff/attendance/leave/staff/allowances/",
	getLeaveStatsForApplying: SERVER_URL + "erp/staff/attendance/leave/apply/stats/",
	staffHolidays: SERVER_URL + "erp/staff/attendance/holidays/",		// to CRUD holidays
	changeLeaveStatus: SERVER_URL + "erp/staff/attendance/leave/approval/",


	// Syllabus:
	getAllLessons: SERVER_URL + "syllabus/modules/",

	//Timetable:
	getTimeSlots: SERVER_URL + "timetable/timeslots/",
	getTimeTableItems: SERVER_URL + "timetable/items/",
	createTimeTable: SERVER_URL + "timetable/items/multiple/",
	classTimetable: SERVER_URL + "timetable/timeslots/items/",

	// Task management:
	tasks: SERVER_URL + 'tasks/tasks/',
	taskTags: SERVER_URL + 'tasks/tags/',
	taskComments: SERVER_URL + 'tasks/comments/',

	// onboarding
	temporaryInstitution: SERVER_URL + 'onboarding/tempinstitution/',
	createSectionCategory: SERVER_URL + 'onboarding/create-section-category/',
	createClassrooms: SERVER_URL + 'onboarding/create-classrooms/',
	createStudentRecords: SERVER_URL + 'onboarding/create-students/',
	createStaffRecords: SERVER_URL + 'onboarding/create-staff/',
	
	// import excel:
	importExcelStudents: SERVER_URL + 'erp/students/import/data/',
	importExcelStaff: SERVER_URL + 'erp/staff/import/data/',
	importEnquiryDetails: SERVER_URL + 'erp/admission/enquiry/import/',
	importTransactions: SERVER_URL + 'finance/import/',
	importFeeCategories: SERVER_URL + 'erp/fees/categories/import/',

	// Documents & Templates
	documentTypes: SERVER_URL + 'templating/document-types/',
	documentInstances: SERVER_URL + 'templating/document-instances/',
	documentImport: SERVER_URL + 'templating/document-import/',

	// help section
	helpGroups: SERVER_URL + 'help/group/',
	helpSubGroups: SERVER_URL + 'help/sub-group/',
	helpFAQs: SERVER_URL + 'help/faq/',

	//report cards
	downloadSubjectWiseSheet: SERVER_URL + 'erp/report-card/subject-wise-sheet/',
	uploadAllSubjectSheet: SERVER_URL + 'erp/report-card/all-subjects-graded-sheet',
	

	// static templates for export
	static: {
		studentImportFile: SERVER_URL + 'static/import_files/Students_SampleImport.xls',
		staffImportFile: SERVER_URL + 'static/import_files/Staff_SampleImport.xls',
		enquiryImportFile: SERVER_URL + 'static/import_files/Enquiry_SampleImport.xls',
		transactionsImportFile: SERVER_URL + 'static/import_files/Transactions_SampleImport.xls',
		feeCategoriesImportFile: SERVER_URL + 'static/import_files/FeeCategories_SampleImport.xls',
	}
}

export default endpoints;  